// extracted by mini-css-extract-plugin
export default {"strip":"S1AYDJ","root":"OyZG9q","arrow":"bS475B","textArea":"V9nSJh","title":"lqqKOH","subTitle":"azoJhR"};